import React from 'react';
import { Row, Col } from 'src/componentes/grid';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { capitalizeFirstLetter } from 'src/utils/string';

import Input from 'src/componentes/input';
import Checkbox from 'src/componentes/checkbox';
import DatePicker from 'src/componentes/date-picker';
import ResponsavelLookup from 'src/lookups/colaborador';
import DigitadorLookup from 'src/lookups/colaborador';
import StatusReuniaoLookup from 'src/lookups/status-reuniao';
import TagLookup from 'src/lookups/TagLookup';
import ItemOrganizacaoLookup from 'src/lookups/item-organizacao';
import ItemLookup from 'src/lookups/item';
import ObjetivoLookup from 'src/lookups/objetivo';
import PanelCollapse from 'src/componentes/panel-collapse';

class ReuniaoSearch extends React.Component {
  render() {
    let { model, resources, intl } = this.props;

    return (
      <div>
        <PanelCollapse
          open={true}
          header={capitalizeFirstLetter(
            intl.formatMessage({
              id: 'label.informacoesBasicas',
            })
          )}
          ehAccordionDrawer={true}
        >
          <Row>
            <Col md={12}>
              <Input model={model.getModel('assunto')} />
            </Col>
            <Col md={12}>
              <Input model={model.getModel('idIntegracao')} />
            </Col>
            <Col md={12}>
              <ItemOrganizacaoLookup
                multi={true}
                model={{
                  label: capitalizeFirstLetter(resources.area),
                  value: model.getModel('areas').value,
                  requestChange: model.getModel('areas').requestChange,
                }}
                data={{ tiposIdSelecionaveis: [1, 2, 3] }}
              />
            </Col>
            <Col md={6}>
              <DatePicker
                timeformat
                placeholder={intl.formatMessage({ id: 'label.selecioneAHora' })}
                model={model.getModel('dataInicioItem')}
              />
            </Col>
            <Col md={6}>
              <DatePicker
                timeformat
                placeholder={intl.formatMessage({ id: 'label.selecioneAHora' })}
                model={model.getModel('dataTerminoItem')}
              />
            </Col>
            <Col md={12}>
              <ResponsavelLookup
                multi={true}
                model={{
                  label: capitalizeFirstLetter(resources.responsaveis),
                  value: model.getModel('responsaveis').value,
                  requestChange: model.getModel('responsaveis').requestChange,
                }}
              />
            </Col>
            <Col md={12}>
              <DigitadorLookup
                multi={true}
                model={{
                  label: intl.formatMessage({ id: 'label.participantes' }),
                  value: model.getModel('participantes').value,
                  requestChange: model.getModel('participantes').requestChange,
                }}
              />
            </Col>
            <Col md={12}>
              <StatusReuniaoLookup
                model={model.getModel('statusReuniao')}
                data={{ idsSelecionados: [1, 2, 3, 4, 5] }}
              />
            </Col>
            <Col md={12} style={{ marginBottom: 27 }}>
              <Checkbox
                model={model.getModel('utilizaRecorrencia')}
                style={{ marginTop: 9 }}
              />
            </Col>
          </Row>
        </PanelCollapse>
        <PanelCollapse
          header={capitalizeFirstLetter(
            intl.formatMessage({ id: 'informacoesComplementares' })
          )}
          open={false}
          ehAccordionDrawer={true}
        >
          <Row>
            <Col md={12}>
              <ItemLookup
                clearable={true}
                multi={true}
                model={{
                  label: capitalizeFirstLetter(
                    intl.formatMessage({ id: 'itensRelacionados' })
                  ),
                  value: model.getModel('itensRelacionados').value,
                  requestChange:
                    model.getModel('itensRelacionados').requestChange,
                }}
                data={{ tiposIdsSelecionados: [1, 2, 3, 4] }}
              />
            </Col>
            <Col md={12}>
              <ObjetivoLookup
                clearable
                multi={true}
                model={{
                  label: capitalizeFirstLetter(
                    intl.formatMessage({
                      id: 'okrsRelacionados',
                    })
                  ),
                  value: model.getModel('okrsRelacionados').value,
                  requestChange:
                    model.getModel('okrsRelacionados').requestChange,
                }}
              />
            </Col>
            <Col md={12}>
              <TagLookup
                multi
                model={{
                  label: capitalizeFirstLetter(
                    intl.formatMessage({ id: 'tags' }, { tags: resources.tags })
                  ),
                  value: model.getModel('tags').value,
                  requestChange: model.getModel('tags').requestChange,
                }}
                data={{ funcionalidadesIdSelecionaveis: [11] }}
                podeEditar={false}
              />
            </Col>
          </Row>
        </PanelCollapse>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
    configuracaoSistema: state.user.configuracao,
  };
}

export default injectIntl(connect(mapStateToProps)(ReuniaoSearch));
